import React from 'react';
import { useNavigate } from "react-router-dom";
import './home.css';

type GameInfo = {
  modelId?: string;
  name?: string;
};

function Home() {
  const navigate = useNavigate();

  const [loading, setLoading] = React.useState(true);
  const [games, setGames] = React.useState<GameInfo[]>([]);

  React.useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        const url = `${process.env.REACT_APP_API_URL}/slots/get-all-games-info`;
        const res = await fetch(url, {
          method: 'GET',
          credentials: 'include',
        });

        const data = (await res.json()) as unknown;
        if (cancelled) return;

        const list = Array.isArray(data) ? (data as GameInfo[]) : [];
        const normalized = list
          .filter((g) => !!g && typeof g.modelId === 'string' && g.modelId.length > 0)
          .map((g) => ({
            modelId: g.modelId,
            name: typeof g.name === 'string' ? g.name : '',
          }))
          .sort((a, b) => (a.modelId || '').localeCompare(b.modelId || ''));

        setGames(normalized);
      } catch {
        if (cancelled) return;
        setGames([]);
      } finally {
        if (cancelled) return;
        setLoading(false);
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className='home-content'>
      {loading ? <h3>Loading…</h3> : null}
      {!loading && games.length === 0 ? <h3>No games found</h3> : null}
      {games.map((g) => (
        <h3 key={g.modelId} onClick={() => navigate(`/${g.modelId}`)}>
          {`${g.modelId} - ${g.name || ''}`}
        </h3>
      ))}
    </div>
  );
}

export default Home;
